import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isUserAuthenticated } from "../modules/common";
import { FormRegistrazione, UserNotAuthenticated } from "../components";
import { NOT_AUTHENTICATED_EVENT, NOT_AUTHORIZED_EVENT } from "../utility";
import packageJson from "../../package.json";
import { Typography } from "@mui/material";
import { ModalInfoUser } from "../components/pages/ModalInfoUser";
import { getProfilo } from "../modules/osservatorio";

export const MainContent = () => {
  const dispatch = useDispatch();
  const [userNotAuthenticated, setUserNotAuthenticated] = useState(false);
  const [userNotAuthorized, setUserNotAuthorized] = useState(false);
  const [userDisabled, setUserDisabled] = useState(false);
  const profilo = useSelector(getProfilo);
  const date = new Date();
  const dateStopDisplayAlert = new Date("2024-10-15");

  useEffect(() => {
    window.addEventListener(NOT_AUTHENTICATED_EVENT, (e) => setUserNotAuthenticated(true), false);
    window.addEventListener(NOT_AUTHORIZED_EVENT, (e) => setUserNotAuthorized(true), false);
    dispatch(isUserAuthenticated());
    if (window.location.search.includes("?utenteAutenticato=true")) window.location.href = window.origin + "/" + packageJson.homepage;
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (profilo !== null)
      if (profilo.disabilitato === true)
        if (date < dateStopDisplayAlert) {
          setUserDisabled(true);
        }
    // eslint-disable-next-line
  }, [profilo]);

  return (
    <main id="mainContent">
      <Typography variant="h1" sx={{ position: "absolute", left: "-999999px" }}>
        Accesso Scuola Digitale Liguria
      </Typography>
      {userNotAuthorized && <FormRegistrazione />}
      <ModalInfoUser open={userDisabled} contenuto="avvisoDisabilitazioneUtente" onClose={() => setUserDisabled(false)} />
      <UserNotAuthenticated open={userNotAuthenticated} />
    </main>
  );
};
